<template>
  <div>
    <v-app-bar flat color="white">
      <div class="pa-2">
        <agency-dialog-component
          ref="refDialogComponent"
          @updated="updated"
        ></agency-dialog-component>
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import agencyDialogComponent from "./component/agencyDialogComponent.vue";

export default {
  components: {
    agencyDialogComponent,
  },
  setup(props, ctx) {
    const refDialogComponent = ref(null);

    // app-barにあるコンポーネント呼び出し
    const action = (params) => {
      switch (params.action) {
        case "edit":
          refDialogComponent.value.editDialog(params.value);
          break;
      }
    };

    const updated = (agency_data) => {
      ctx.emit("updated", agency_data);
    };

    return {
      refDialogComponent,
      action,
      updated,
    };
  },
};
</script>
